'use client';
import { hasVisibleHtmlContent } from '../../../util/hasVisibleHtmlContent';
import { Card, CardBody, CardHeader } from '../../Card';
import { HTML } from '../../Html';
import { Title } from '../../Title';
import type { PostDescriptionProps } from './PostDescription.types';

export const PostDescription = ({ title: rawTitle, description, ...otherProps }: PostDescriptionProps) => {
  const title = rawTitle?.trim();
  const hasDescription = hasVisibleHtmlContent(description);

  if (!title && !hasDescription) {
    return;
  }

  return (
    <Card {...otherProps}>
      {title && (
        <CardHeader>
          <Title typography="headingLg" component="h2">
            {title}
          </Title>
        </CardHeader>
      )}
      {hasDescription && (
        <CardBody>
          <HTML html={description} />
        </CardBody>
      )}
    </Card>
  );
};
